import React from 'react';
import Hero from '../components/Hero';
import Story from '../components/Story';
import MissionBrief from '../components/MissionBrief';
import AetherReveal from '../components/AetherReveal';

function Home() {
  return (
    <>
      <Hero />
      <div className="gold-divider">
        <div className="line reveal"></div>
      </div>
      <Story />
      <div className="gold-divider">
        <div className="line reveal"></div>
      </div>
      <MissionBrief />
      <div className="gold-divider">
        <div className="line reveal"></div>
      </div>
      <AetherReveal />
    </>
  );
}

export default Home;
